<div class="rfq-setup-container" [formGroup]="form">
  <div class="rfq-side-bar">
    <button
      class="ui-button primary rfq-side-bar__arrow"
      (click)="show = !show"
    >
      <span
        class="rfq-side-bar__arrow__Text"
        [ngClass]="{ 'rfq-side-bar__arrow__Text--closed': !show }"
      >
        >
      </span>
    </button>
  </div>
  <div class="rfq-setup-content-container" [ngClass]="{ hide: !show }">
    <div class="rfq-setup-content">
      <div class="rfq-setup-content__form">
        <span class="rfq-setup-content__row">
          <label class="rfq-setup-content__label"> Request ID </label>
          <span> {{ requestId }} </span>
        </span>

        <span class="rfq-setup-content__row">
          <label class="rfq-setup-content__label"> Account </label>
          <span> {{ displayedAccount || account }} </span>
        </span>

        <span class="rfq-setup-content__row">
          <label class="rfq-setup-content__label"> Prime Broker </label>
          <span> {{ broker }} </span>
        </span>

        <span class="rfq-setup-content__row">
          <label class="rfq-setup-content__label"> Premium </label>
          <span> {{ premiumCCY }} </span>
        </span>

        <span class="rfq-setup-content__row bolder">
          <label class="rfq-setup-content__label"> Premium Value </label>
          <span> {{ premiumValue }} </span>
        </span>

        <span class="rfq-setup-content__row bolder">
          <label class="rfq-setup-content__label"> Premium Date </label>
          <span> {{ premiumDate }} </span>
        </span>

        <div class="rfq-setup-content__row bolder">
          <label class="rfq-setup-content__label"> Hedge </label>
          <div class="hedge-container">
            <span class="hedge-container__hedge"> {{ hedge }} </span>
            <span class="hedge-container__hedge-input" *ngIf="hedgeRate">
              {{ hedgeRate | number: '1.4-4' }}
            </span>
          </div>
        </div>

        <div
          class="rfq-setup-content__row bolder"
          *ngIf="form.controls['spots']"
          formGroupName="spots"
        >
          <label class="rfq-setup-content__label"> Market Spot </label>
          <div class="spots-input-container">
            <input-with-spinner
              class="spot-input"
              formControlName="spotBid"
              [className]="'spotBid'"
              [inputValidator]="['positiveNumber']"
              [textColor]="spotInfo.bid.color"
              [flashOnChange]="spotInfo.bid.flashOnChange"
              [showSpinner]="spotInfo.bid.showSpinner"
              (inputChange)="spotFieldEdited('bid')"
              (onBlur)="spotFieldBlurred('bid')"
              (onFocus)="onElemFocus()"
            ></input-with-spinner>
            <span> / </span>
            <input-with-spinner
              class="spot-input"
              formControlName="spotAsk"
              [className]="'spotAsk'"
              [inputValidator]="['positiveNumber']"
              [textColor]="spotInfo.ask.color"
              [flashOnChange]="spotInfo.ask.flashOnChange"
              [showSpinner]="spotInfo.ask.showSpinner"
              (inputChange)="spotFieldEdited('ask')"
              (onBlur)="spotFieldBlurred('ask')"
              (onFocus)="onElemFocus()"
            ></input-with-spinner>
            <div
              class="icon-wrapper"
              *ngIf="
                !form.controls['spots'].valid && form.controls['spots'].dirty
              "
              [title]="'Ask must be bigger or equal to bid'"
            >
              <cds-icon
                class="alert-icon"
                shape="exclamation-circle"
              ></cds-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="hedge !== 'None'">
    <app-provider-multi-hedge-group
      [groupName]="''"
      [hedgeMode]="hedge"
      [setupForm]="form"
      [volBased]="tabItem.isVolBased"
      [isCustomHedge]="hedgeRate !== undefined"
      [cross]="cross"
      (fieldBlur)="changeInForm()"
      [showExpiryDate]="showExpiryDate"
    ></app-provider-multi-hedge-group>
  </ng-container>
</div>
